
import {AppLink as Link, AppWrapper} from "../components/helpers";
import app from "../components/app";
import {appCookie} from "./login";
console.log(app.config().projects);
export default function Pages(props) {
   return <AppWrapper>
     <div className="container-fluid p-2">
   
         <div className="row p-2">
          {
            app.config().projects.map(function(v){
              return<div className="col-3 p-2">
                
                
             <div className="card">
              <img className="card-img-top" src="/images/video-default.png" alt={v.name}></img>
  
  <div className="card-body">
    <h5 className="card-title">{v.name}</h5>
    <Link  href="/preview" className="btn btn-primary me-2">Preview</Link>
    <Link  href={`/${v.domain}`} className="btn btn-primary me-2">Edit Site</Link>
  </div>
</div>
          </div>
            })
          }


          <div className="col-3 p-2">
                
                
             <div className="card">
              <img className="card-img-top" src="/images/video-default.png" />
  
  <div className="card-body">
    <h5 className="card-title">Templates</h5>
    <Link  href={`/templates`} className="btn btn-primary me-2">Manage Templates</Link>
  </div>
</div>
          </div>

           <div className="col-3 p-2">
                
                
             <div className="card">
              <img className="card-img-top" src="/images/video-default.png" />
  
  <div className="card-body">
    <h5 className="card-title">Blocks</h5>
    <Link  href={`/blocks`} className="btn btn-primary me-2">Manage Blocks</Link>
  </div>
</div>
          </div>
          {appCookie.appUser().role === "admin"?<div className="col-3 p-2">
                
                
             <div className="card">
              <img className="card-img-top" src="/images/video-default.png" />
  
  <div className="card-body">
    <h5 className="card-title">Users</h5>
    <Link  href={`/users`} className="btn btn-primary me-2">Manage Users</Link>
  </div>
</div>
          </div>:""}

           {appCookie.appUser().role === "admin"?<div className="col-3 p-2">
                
                
             <div className="card">
              <img className="card-img-top" src="/images/video-default.png" />
  
  <div className="card-body">
    <h5 className="card-title">Modules</h5>
    <Link  href={`/modules`} className="btn btn-primary me-2">Manage Modules</Link>
  </div>
</div>
          </div>:""}
            
            
    
      
             </div>
         </div>
     
    </AppWrapper>
}